<div class="outbound-campaigns-container">
  <!-- Header -->
  <div class="outbound-campaigns-header">
    <div class="title-section">
      <h1 i18n="@@campaigns.title">Outbound Campaigns</h1>
      <p class="subtitle" i18n="@@campaigns.subtitle">Manage your outbound calling campaigns and contact lists</p>
    </div>
    <div class="actions-section">
      <p-button
        i18n-label="@@campaigns.new"
        label="New Campaign"
        icon="pi pi-plus"
        (click)="createNewCampaign()">
      </p-button>
    </div>
  </div>

  <!-- Filters Panel -->
  <div class="filters-panel">
    <div class="filters-grid">
      <div class="filter-item">
        <label for="status-filter" i18n="@@conversations.filter.status">Status</label>
        <p-select
          id="status-filter"
          [(ngModel)]="selectedStatus"
          [options]="statusOptions"
          optionLabel="label"
          optionValue="value"
          i18n-placeholder="@@conversations.filter.allStatuses"
          placeholder="All statuses"
          [showClear]="true"
          (onChange)="onFilterChange()"
          class="filter-select">
        </p-select>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-wrapper">
    <p-table
      #dt
      [value]="campaigns"
      [virtualScroll]="true"
      [virtualScrollItemSize]="60"
      [virtualScrollOptions]="virtualScrollOptions"
      [rowTrackBy]="trackByCampaignId"
      class="campaigns-table"
      [scrollable]="true"
      scrollHeight="flex">
      <ng-template #header>
        <tr>
          <th style="width: 30%;" i18n="@@agents.col.name">Name</th>
          <th style="width: 25%;" i18n="@@conversations.col.date">Date</th>
          <th style="width: 20%;" i18n="@@conversations.col.status">Status</th>
          <th style="width: 25%;" i18n="@@campaigns.col.items">Items</th>
        </tr>
      </ng-template>

      <ng-template #body let-rowData let-columns="columns">
        <tr class="campaign-row" (click)="editCampaign(rowData)">
          <td>{{ rowData.title || unnamedLabel }}</td>
          <td>{{ rowData.created_at | date:'MMM d, yyyy, h:mm a' }}</td>
          <td>
            <p-tag
              [value]="getStatusLabel(rowData.status)"
              [severity]="getStatusSeverity(rowData.status)">
            </p-tag>
          </td>
          <td>{{ rowData.items_count ?? '-' }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        @if (!isLoading) {
          <tr>
            <td colspan="4" class="empty-message" i18n="@@campaigns.empty">
              No campaigns found. Create your first outbound campaign to get started.
            </td>
          </tr>
        }
      </ng-template>

      <ng-template pTemplate="footer">
        @if (isLoading) {
          <tr>
            <td colspan="4" style="text-align: center; padding: 1rem;">
              <p-progressSpinner [style]="{ width: '30px', height: '30px' }" />
            </td>
          </tr>
        }
      </ng-template>
    </p-table>
  </div>

  <!-- Mobile Bottom Bar -->
  <div class="mobile-bottom-bar">
    <div class="mobile-bottom-actions">
      <p-button
        i18n-label="@@campaigns.new"
        label="New Campaign"
        icon="pi pi-plus"
        (click)="createNewCampaign()">
      </p-button>
    </div>
  </div>
</div>
